import { Modal } from "react-bootstrap";
import { useState } from "react";
import { Button } from "../button";
import { GenericForm } from "../generic-form";
import { useTranslation } from "react-i18next";
import { useToast } from "../toast";
import "./RequestQdsModal.style.css";

import { RequestQdsModalProps } from "./RequestQdsModal.types";
import { QdsRequestDTO } from "../../entities/IQdsRequest";
import UserGateway from "../../api/gateways/UserGateway";

export const RequestQdsModal = ({
  isVisible,
  onDismiss,
  onSubmit,
  creating,
  requestQdsForm,
}: RequestQdsModalProps) => {
  const { t } = useTranslation();
  const { danger } = useToast();
  const [validating, setValidating] = useState(false);
  const [invalidEmails, setInvalidEmails] = useState<string[] | null>(null);

  const handleSubmit = async (data: any) => {
    const processedData: QdsRequestDTO = {
      documentId: data.documentId,
      consentEmails: data.consentEmails || [],
      holderSignerEmails: data.holderSignerEmails || [],
      counterPartyEmails: data.counterPartyEmails || [],
    };

    if (!processedData.holderSignerEmails.length && !processedData.counterPartyEmails.length) {
      danger(t("QDS_REQUEST.MISSING_SIGNERS_ERROR"));
      return;
    }

    const emailsToCheck = [
      ...processedData.consentEmails,
      ...processedData.holderSignerEmails,
    ];

    if (emailsToCheck.length === 0) {
      onSubmit(processedData as any);
      return;
    }

    setValidating(true);
    try {
      const result = await UserGateway.checkEmails(emailsToCheck);
      if (result.valid) {
        onSubmit(processedData as any);
      } else {
        setInvalidEmails(result.invalidEmails);
      }
    } catch {
      danger(t("ERRORS.UNKNOWN"));
    } finally {
      setValidating(false);
    }
  };

  const handleDismissError = () => {
    setInvalidEmails(null);
  };

  return (
    <Modal show={isVisible} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="Qds Modal">
          {t("DOCUMENTS.CREATE_QUALIFIED_DIGITAL_SIGNATURE_REQUEST")}
        </h5>
        <div onClick={onDismiss}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: invalidEmails !== null ? "none" : "block" }}>
          <GenericForm
            form={requestQdsForm}
            onSubmit={handleSubmit}
            submitControl={(submit) => (
              <div className="flex-row">
                <Button
                  isLoading={creating || validating}
                  loader={{ size: "s" }}
                  className="btn btn-danger mt-3 w-100 request-qds-btn"
                  type="submit"
                  disabled={validating}
                >
                  {validating ? t("QDS_REQUEST.VALIDATING") : t("REQUEST_BUTTON")}
                </Button>
              </div>
            )}
          />
        </div>
        {invalidEmails !== null && (
          <div>
            <p className="mb-2">{t("QDS_REQUEST.INVALID_EMAILS_MESSAGE")}</p>
            <ul className="mb-3">
              {invalidEmails.map((email) => (
                <li key={email}>{email}</li>
              ))}
            </ul>
            <Button
              className="btn btn-primary w-100"
              onClick={handleDismissError}
            >
              OK
            </Button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};
